import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { ListPublicationStatesDashboardContainerProps } from "../../../../interfaces/containers";
import ListPublicationStates from "../../../../pages/Profile/Dashboard/ListPublicationStates";
import {
    getStatusChangesPublications,
    cleanStatusChangesPublications,
    getStatusChangesTransactions,
    cleanStatusChangesTransactions 
} from "../../../../actions/dashboard";

function mapStateToProps(state: ListPublicationStatesDashboardContainerProps) {
    return {
        user: state.auth.user,
        branch: state.profile.dashboard.branch,
        statusChanges: state.profile.dashboard.statusChanges,
        date: state.profile.dashboard.date
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getStatusChangesPublications,
        cleanStatusChangesPublications,
        getStatusChangesTransactions,
        cleanStatusChangesTransactions
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(ListPublicationStates);